import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {Navbar} from './navbar';
import {Footer} from './footer';
import DeliveryPartnerLocationTracker from '@/components/delivery/DeliveryPartnerLocationTracker';
import { getRoutes } from "@/routes";
import { useTranslation } from "react-i18next";

const DeliveryDashboard = () => {
  const { t } = useTranslation('sidebar');
  const routes = getRoutes(t);

  return (
   <div className="flex flex-col min-h-screen bg-gray-50">
    <DeliveryPartnerLocationTracker />
    <Navbar />
     <main className="flex-grow w-full min-w-0 pb-[env(safe-area-inset-bottom,0px)]">
          <Routes>
            {routes.map(
              ({ layout, pages }) =>
                layout === "delivery-partner" &&
                pages.map(({ path, element }) => (
                  <Route
                    key={path}
                    path={path}
                    element={element}
                  />
                ))
            )}
          </Routes>
      </main>
      <Footer/>
    </div>
  );
};

export default DeliveryDashboard;